import { useCallback } from 'react';
import { z } from 'zod';
import { useLocalStorage } from './use-local-storage.ts';

type UseDismissibleHint = {
    isDismissed: boolean;
    dismiss: () => void;
};

export function useDismissibleHint(storageKey: string): UseDismissibleHint {
    const [isDismissed, setIsDismissed] = useLocalStorage<boolean>(storageKey, false, {
        schema: z.boolean(),
    });

    const dismiss = useCallback((): void => {
        setIsDismissed(true);
    }, [setIsDismissed]);

    return { isDismissed, dismiss };
}
